import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    background: lightColors.background
};
export var dark = {
    background: darkColors.background
};
